import { useEffect } from 'react'
import PageMeta from 'components/PageMeta'
import { withApollo } from 'components/withApollo'
import { NextPage } from 'next'
import TrucksAppLinks from 'components/TrucksAppLinks'
import { useRouter } from 'next/router'

function TrucksAppPage() {
  const router = useRouter()
  const { appPath } = router.query

  const appUrl = appPath
    ? `bft://${(appPath as string[]).join('/') || 'home'}`
    : 'bft://home'

  useEffect(() => {
    const isAndroid = /(android)/i.test(navigator.userAgent)
    const isIOS =
      // eslint-disable-next-line
      /iPad|iPhone|iPod/i.test(navigator.userAgent) && !(window as any).MSStream
    if (isAndroid || isIOS) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ;(window as any).location = appUrl
    }
  }, [appUrl])

  return (
    <>
      <PageMeta
        canonicalPath="/trucks/app"
        description="Trucks App"
        title="Best Food Trucks | App For Vendors"
      />
      <div className="w-full h-screen bg-gray-900 text-color-white py-16">
        <TrucksAppLinks
          androidLink="https://play.google.com/store/apps/details?id=com.bft"
          iosLink="https://apps.apple.com/us/app/best-food-trucks-bft/id1354908972"
          title="Download BFT App for Vendors"
        />
      </div>
    </>
  )
}

const TrucksAppPageWithApollo = withApollo({ ssr: true })(
  TrucksAppPage as NextPage
)
export default TrucksAppPageWithApollo
